<template>
	<div class="did-you-know">
		<playbooks-svg-did-you-know />
		<div>
			<strong>Did you know?</strong>
			<p>Gamified optins have been known to turn 2-3% conversion rates into conversion rates of 30% or more!</p>
			<p>
				<a :href="didYouKnowLink" class="button secondary" target="_blank" rel="noopener"> Learn More </a>
			</p>
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		/**
		 * Generate the link for the 'Learn More' button in the 'Did You Know' section.
		 *
		 * @returns {string} The link URL
		 */
		didYouKnowLink() {
			return this.$urls.docs(
				'how-to-create-a-gamified-spin-to-win-coupon-wheel-popup-campaign',
				'PlaybooksDidYouKnow'
			);
		},
	},
};
</script>
